import React from "react";

export const Previous = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22872 11.4751C7.62865 11.856 7.64409 12.4889 7.2632 12.8889C6.88231 13.2888 6.24934 13.3042 5.84941 12.9234L7.22872 11.4751ZM1.47441 8.75669C1.07448 8.3758 1.05904 7.74283 1.43992 7.3429C1.82081 6.94297 2.45379 6.92753 2.85372 7.30841L1.47441 8.75669ZM2.85372 8.75669C2.45379 9.13758 1.82081 9.12214 1.43992 8.72221C1.05904 8.32228 1.07448 7.6893 1.47441 7.30841L2.85372 8.75669ZM5.84941 3.14175C6.24934 2.76086 6.88231 2.7763 7.2632 3.17623C7.64409 3.57616 7.62865 4.20914 7.22872 4.59002L5.84941 3.14175ZM2.16406 9.03255C1.61178 9.03255 1.16406 8.58484 1.16406 8.03255C1.16406 7.48027 1.61178 7.03255 2.16406 7.03255V9.03255ZM13.8307 7.03255C14.383 7.03255 14.8307 7.48027 14.8307 8.03255C14.8307 8.58484 14.383 9.03255 13.8307 9.03255V7.03255ZM5.84941 12.9234L1.47441 8.75669L2.85372 7.30841L7.22872 11.4751L5.84941 12.9234ZM1.47441 7.30841L5.84941 3.14175L7.22872 4.59002L2.85372 8.75669L1.47441 7.30841ZM2.16406 7.03255L13.8307 7.03255V9.03255L2.16406 9.03255V7.03255Z"
        fill="white"
      />
    </svg>
  );
};
